import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CustomMaterialModule } from './core/material.module';
import { DataTablesModule } from 'angular-datatables';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HttpAuthInterceptor } from './http-auth-interceptor';
import { AuthService } from './servicios/auth.service';
import { Myfilterpipe } from './utils/myfilterpipe';
import {
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS
} from '@angular/material/core';
import { DialogEditPersonaComponent } from './dialogs/dialog-edit-persona/dialog-edit-persona.component';
import { DialogCopiarEncuestaComponent } from './dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component';
import { ServicioComponent } from './servicio/servicio.component';
import { CrearServicioComponent } from './servicio/crear-servicio/crear-servicio.component';
import { ModificarServicioComponent } from './servicio/modificar-servicio/modificar-servicio.component';
import { CreacionPaqueteComponent } from './servicio/creacion-paquete/creacion-paquete.component';
import { ModificarPaqueteComponent } from './servicio/modificar-paquete/modificar-paquete.component';
import { from } from 'rxjs';
import { DialogDocumentoComponent } from './dialogs/dialog-documento/dialog-documento.component';
import { DialogWebServiceComponent } from './dialogs/dialog-web-service/dialog-web-service.component';
import { VerticalTimelineModule } from 'angular-vertical-timeline';
import { DialogAgenciasComponent } from './dialogs/dialog-agencias/dialog-agencias.component';
import { MglTimelineModule } from 'angular-mgl-timeline';
import { FilterPipe } from './pipes/filter.pipe';
import { EntregasTransportadorComponent } from './entregas-transportador/entregas-transportador.component';
import { NavigationComponent } from './navigation/navigation.component';
import { ModificarDireccionPersonaComponent } from './components/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component';
import { ModificarUsuarioPersonaComponent } from './components/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component';
import { DialogAlertComponent } from "./dialogs/dialog-alert/dialog-alert.component";
import { DialogConfirmationComponent } from "./dialogs/dialog-alert-confirmation/dialog-confirmation.component";
import { DialogAlertTextComponent } from "./dialogs/dialog-alert-text/dialog-alert-text.component";

@NgModule({
  declarations: [
    AppComponent,
    routingComponents,
    Myfilterpipe,
    DialogEditPersonaComponent,
    DialogCopiarEncuestaComponent,
    ServicioComponent,
    CrearServicioComponent,
    ModificarServicioComponent,
    CreacionPaqueteComponent,
    ModificarPaqueteComponent,
    DialogDocumentoComponent,
    DialogWebServiceComponent,
    DialogAgenciasComponent,
    FilterPipe,
    EntregasTransportadorComponent,
    NavigationComponent,
    ModificarDireccionPersonaComponent,
    ModificarUsuarioPersonaComponent,
    DialogAlertComponent,
    DialogConfirmationComponent,
    DialogAlertTextComponent,
  ],
  entryComponents: [DialogEditPersonaComponent, DialogCopiarEncuestaComponent, DialogDocumentoComponent, DialogWebServiceComponent, DialogAgenciasComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    CustomMaterialModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxFileDropModule,
    DataTablesModule,
    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: 'modal-content',
      confirmButtonClass: 'btn btn-primary',
      cancelButtonClass: 'btn'
    }),
    NgScrollbarModule,
    VerticalTimelineModule,
    MglTimelineModule
  ],
  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
